import Link from 'next/link';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { routes } from '@/shared/helpers';
import { getPersonFullName } from '@/shared/helpers/names';
import { CoOwner, useSJDatabase } from '@/shared/lib/sj-orm';

const EMPTY_TEXT = '-';

export const useCoOwners = (isPdf?: boolean) => {
  const sjDb = useSJDatabase();

  const getCoOwnerName = (coOwner: CoOwner) => {
    if (!coOwner.coOwnerEntityDtoId) return '-';

    const beneficiary = sjDb.collections.beneficiaries?.findById(coOwner.coOwnerEntityDtoId);
    if (beneficiary) return getPersonFullName(beneficiary, 'display');

    const contact = sjDb.collections.contacts?.findById(coOwner.coOwnerEntityDtoId);
    if (contact) return contact.nickname;

    return EMPTY_TEXT;
  };

  const getCoOwnerDocument = (coOwner: CoOwner) => {
    const items = (
      coOwner.coOwnerDocument?.map((itemId, index, { length }) => {
        const personalId = sjDb.collections.personalIdentifiersDocuments?.findById(itemId);
        if (personalId) {
          const text = `${personalId.name}${index === length - 1 ? '' : ','}`;
          return isPdf ? (
            text
          ) : (
            <StyledLink key={itemId} href={routes.personalId(itemId)}>
              {text}
            </StyledLink>
          );
        }

        const privateDocument = sjDb.collections.privateDocuments?.findById(itemId);
        if (privateDocument) {
          const text = `${privateDocument.name}${index === length - 1 ? '' : ','}`;
          return isPdf ? (
            text
          ) : (
            <StyledLink key={itemId} href={routes.privateDocument(itemId)}>
              {text}
            </StyledLink>
          );
        }

        return null;
      }) ?? []
    ).filter(Boolean);

    const element = isPdf ? items : <div style={{ display: 'flex', gap: 8 }}>{items}</div>;

    return items.length ? element : EMPTY_TEXT;
  };

  return { getCoOwnerName, getCoOwnerDocument };
};

export const StyledLink = styled(Link)`
  &&& {
    color: ${COLORS.systemSky200};
  }
`;
